var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Hoppsan! Den sidan finns inte")]),_c('p',[_vm._v("Vi hittar inte sidan du söker. Testa att leta via "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("startsidan")]),_vm._v(".")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }